<template>
  <div class="page-wrapper">
    <header class="navbar">
      <div class="logo-wrap">
        <img class="logo" src="@/assets/img/substance-ddmg-logo.png" alt="Substance" />
      </div>
      <div class="right">
        <a href="#programmation" v-scroll-to:-95 class="link"><p class="caps-bold">HORAIRE<span> DE LA JOURNÉE</span></p></a>
        <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">PARTICIPER</p></a>
      </div>
    </header>

    <section class="hero">
      <img class="show-desktop-only" src="@/assets/img/hero-2027.png" alt="Substance Lab 2025">
      <img class="show-mobile-only" src="@/assets/img/hero-2027-mobile.png" alt="Substance Lab 2025">
      <!-- <a href="#" class="cta outline float-cta">Rendez-vous annuel substance</a> -->
    </section>

    <section class="img-bloc stretch">
      <div class="data" data-inview="slideRight" data-delay="200">
        <h2 class="title big">Le LAB<br>Sommet de création, de contenu, de média et de RP</h2>
        <h3 class="title small">Concrétisez vos connaissances sur l'industrie</h3>
        <p class="text">
          Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les relations publiques est de retour. Profitez de formations, conférences, discussions et activité de réseautage pour rester à l'affût de toutes les meilleures pratiques et dernières tendances de l'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos organisations et de vos marques dans l'environnement actuel du marketing.
        </p>

        <div class="wrap-desc">
          <div class="col">
            <p class="text">
              EN BREF
            </p>
            <ul>
              <li class="text">+ de 15 experts</li>
              <li class="text">1&nbsp;&nbsp;journée complète de formations</li>
              <li class="text">Cocktail de réseautage</li>
              <li class="text">Rafraîchissements et lunchs fournis</li>
            </ul>
          </div>
          <div class="col">
            <p class="text">
              SUJETS COUVERTS
            </p>
            <ul>
              <li class="text">Marketing d'influence</li>
              <li class="text">LLM et GEO</li>
              <li class="text">Ecommerce</li>
              <li class="text">Guide de marque numérique</li>
            </ul>
          </div>
        </div>

        <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">SOYEZ DES NÔTRES</p></a>
      </div>
      <div class="img" data-inview="slideLeft" data-delay="200">
        <div class="infos-card">
          <div class="info">
            <p class="title">QUAND</p>
            <p class="info-text">21 janvier 2027 <br> 9h00</p>
          </div>
          <div class="info">
            <p class="title">Où</p>
            <p class="info-text">messorem <small>2233 rue Pitt montréal</small></p>
          </div>
        </div>
      </div>
    </section>

    <section class="video-wrap" data-inview="fadeInUp" data-delay="200">
      <div class="youtube-embed">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/X_J4XiaKN6U?si=1f8Mi_kK8SNlqrLb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </section>

    <section id="programmation" class="programmation">
      <div class="title-wrap">
        <h2 class="title big" data-inview="fadeInUp" data-delay="200">Le Lab Substance 2027</h2>
      </div>

      <!-- Horaire à venir -->
      <div class="coming-soon" data-inview="fadeInUp" data-delay="200">
        <p class="text">Horaire à venir</p>
      </div>
    </section>

    <section class="img-bloc yellow">
      <div class="data" data-inview="slideRight" data-delay="200">
        <h2 class="title medium">NE MANQUEZ PAS ÇA !</h2>
        <p class="text darker">
          Le 21 janvier prochain, on vous attend dès 9h00 à la microbrasserie Messorem.
        </p>
        <h3 class="title small">MESSOREM</h3>
        <p class="text darker">2233 Rue Pitt, Montréal, QC H4E 4H2</p>
        <!-- <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">Confirmer ma présence</p></a> -->
      </div>
      <div class="img" data-inview="slideLeft" data-delay="200">
        <a
          href="https://www.google.com/maps?q=messorem+bracitorium&gs_lcrp=EgZjaHJvbWUqDQgBEC4YrwEYxwEYgAQyBggAEEUYOTINCAEQLhivARjHARiABDIHCAIQABiABDIHCAMQABiABDIHCAQQABiABDIHCAUQABiABDIHCAYQABiABDIHCAcQABiABDIHCAgQABiABNIBCDM2ODJqMGoxqAIAsAIA&um=1&ie=UTF-8"
          target="_blank"
          ><img src="@/assets/img/messorem.svg" alt="Google map"
        /></a>
      </div>
    </section>

    <section class="footer">
      <img class="logo" src="@/assets/img/substance-ddmg-logo.png" alt="Logo Substance">
    </section>

    <!--FORM-->
    <section class="panel-wrap" :class="{ active: form }">
      <div class="panel" v-if="!isSuccess">
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeform" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>

        <p class="title small">Confirmer ma présence</p>

        <!-- Horaire à venir -->
        <div class="coming-soon" data-inview="fadeInUp" data-delay="200">
          <p class="text">Inscriptions à venir</p>
        </div>

      </div>
      <div class="panel success-screen" v-else>
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeform" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>
        
        <p class="title small">Merci de votre <br> inscription!</p>
        <p class="text">
        <br>
        Rendez-vous le 21 janvier prochain à la brasserie Messorem </p>
      </div>
      <div class="overlay" @click.prevent="closeform"></div>
    </section>

    <!--Conférence Panel-->
    <section class="panel-wrap" :class="{ active: conference }">
      <div class="panel">
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeconference" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>

        <div class="event" :class="{ show: show === 'event1' }">
          <div class="top">
            <p class="hour title">10h</p>
            <h3 class="title small">L’IA : entre fantasmes et faits</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
              <p class="text">Impossible de discuter de l'industrie du marketing sans parler intelligence artificielle. Apprenez comment naviguer cette technologie en constante évolution et comment l'intégrer dans vos opérations quotidiennes de manière stratégique, éthique et responsable.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/river-lariviere.png" alt="River Larivière" />
            <p class="text name"><span>/</span>  River Larivière</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/marie-jade.webp" alt="Marie-Jade Filion" />
            <p class="text name"><span>/</span>  Marie-Jade Filion</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/genevieve-harel.png" alt="Geneviève Harel" />
            <p class="text name"><span>/</span> Geneviève Harel</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event2' }">
          <div class="top">
            <p class="hour title">10h</p>
            <h3 class="title small">Micro, Nano, Macro influenceurs : quelle approche privilégier ?</h3>
            <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">On sait toustes que l'influence joue un rôle crucial dans la stratégie, mais c'est une industrie qui change rapidement. Comment activer le bon mix de nano, micro, macro et mega-influenceurs selon le contexte?</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne" />
            <p class="text name"><span>/</span> Marc-André Dufresne</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/martin-alexis.png" alt="Martin Alexis Ramirez" />
            <p class="text name"><span>/</span> Martin Alexis Ramirez</p>
          </div>

          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event3' }">
          <div class="top">
            <p class="hour title">10h30</p>
            <h3 class="title small">L'influence repensée : de création à amplification</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">L'influence, c'est un levier stratégique activable sur l'ensemble du funnel. De l’idéation à la production, jusqu’à l’amplification payante, les marques ont désormais l’opportunité de maximiser la performance de leurs contenus influenceurs.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne">
            <p class="text name"><span>/</span> Marc-André Dufresne</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/elise.webp" alt="Élise El-Nawar ">
            <p class="text name"><span>/</span> Élise El-Nawar</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event4' }">
          <div class="top">
            <p class="hour title">10h30</p>
            <h3 class="title small">De la visibilité à la considération: Brancher les RP au parcours client</h3>
           <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">Les relations publiques, c'est bien plus qu'un bonus de notoriété. C'est un outil de crédibilité essentiel à tout funnel complet, particulièrement en considération. Découvrez comment tirer le meilleur profit de cette tactique et ce, à chaque étape du parcours client.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
            <p class="text name"><span>/</span> Sébastien Voyer</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/juliette-ferland.png" alt="Juliette Ferland" />
            <p class="text name"><span>/</span> Juliette Ferland</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event5' }">
          <div class="top">
            <p class="hour title">11h</p>
            <h3 class="title small">Cas RONA : L'influence au service de la marque</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Dans la dernière année, l'influence a été un véritable moteur de performance. Découvrez la recette qui a renforcé le leadership de RONA dans la rénovation au Canada : une approche d’influence crédible et inspirante qui a solidifié la confiance des communautés envers la marque.</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/vanessa-beauregard.png" alt="Vanessa Beauregard" />
            <p class="text name"><span>/</span> Vanessa Beauregard</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/caroline-hurtubise.png" alt="Caroline Hurtubise"/>
            <p class="text name"><span>/</span> Caroline Hurtubise</p>
          </div>

          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event6' }">
          <div class="top">
            <p class="hour title">11h</p>
            <h3 class="title small">Nos apprentissages pour la recette du Ecom</h3>
           <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">Voici le plan de match essentiel pour des campagnes e-commerce qui transforment les clics en bénéfices. Décortiquons les cinq piliers cruciaux d'une planification média numérique réussie. Si vous cherchez les ingrédients secrets pour maximiser vos rendements, cette session est pour vous.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/philippe.png" alt="Philippe Petrin">
            <p class="text name"><span>/</span> Philippe Petrin</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event7' }">
          <div class="top">
            <p class="hour title">11h30</p>
            <h3 class="title small">GAFAM vs. médias d'ici : Se démarquer pour atteindre les objectifs</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Les médias d'ici tiennent tête aux géants mondiaux comme pôle essentiel dans notre écosystème. Comment mettre à profit de nouvelles technologies et stratégies pour maintenir cette performance et consolider sa place dans le milieu? Assistez à notre panel d'experts.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/guillaume-brunet.png" alt="Guillaume Brunet" />
            <p class="text name"><span>/</span> Guillaume Brunet</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/lapresse.png" alt="La Presse" />
            <p class="text name"><span>/</span> La Presse</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/globe-mail.png" alt="Globe and Mail" />
            <p class="text name"><span>/</span> Globe and Mail</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/cegeco.png" alt="Média Tonik" />
            <p class="text name"><span>/</span> Cogeco</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/pelmorex.png" alt="Pelmorex" />
            <p class="text name"><span>/</span> Pelmorex</p>
          </div>


          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event8' }">
          <div class="top">
            <p class="hour title">13h</p>
            <h3 class="title small">Hear, Hear! How to Make the Most of Spotify's Tools to Reach your Customers</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Spotify is the #1 audio streaming platform in Canada, but that's not the only reason it's a powerful tool for reaching your audience. In this conference, Spotify experts break down how to leverage extensive customer data and insights, optimize personalization and targeting tools, and use their new innovative formats to empower your brand to connect with relevant listeners.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/spotify.png" alt="Spotify" />
            <p class="text name"><span>/</span>  Spotify</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event9' }">
          <div class="top">
            <p class="hour title">13h30</p>
            <h3 class="title small">Étude de cas Nutella | Démêler le vrai du faux: quand les mythes façonnent la réputation des marques</h3>
            <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">La désinformation est à son apogée et elle se propage plus rapidement que jamais. Mais qu'est-ce qui arrive lorsqu'une fabrication affecte la réputation de votre marque? Étudiez le cas Nutella et le mythe de l'huile de palme pour découvrir comment remettre les pendules à l'heure et rétablir la confiance.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
            <p class="text name"><span>/</span> Sébastien Voyer</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event10' }">
          <div class="top">
            <p class="hour title">13h30</p>
            <h3 class="title small">Go Big, Go North: Mastering Canada’s Vast and Diverse Markets</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">

              <p class="text">2025 was the year of Canada-first marketing. But is it here to stay? Here's our lookback on a year marked by this local approach, as well as our thoughts on how to leverage our identities with authenticity moving forward.</p>

          </div>
          <div class="speaker">
            <img src="@/assets/img/ophelie.png" alt="Ophelie Zalcmanis-Lai" />
            <p class="text name"><span>/</span> Ophelie Zalcmanis-Lai</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/river-lariviere.png" alt="River Larivière" />
            <p class="text name"><span>/</span> River Larivière</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event11' }">
          <div class="top">
            <p class="hour title">14h10</p>
            <h3 class="title small">Insight-Out Growth</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">

              <p class="text">Learn how to turn raw data into meaningful customer realities to drive campaigns that truly resonate with your audience. The key? Start with insight, move with purpose, and let customer truth compound into momentum.</p>

          </div>
          <div class="speaker">
              <img src="@/assets/img/ron-tite.png" alt="" />
              <p class="text name"><span>/</span> Ron Tite</p>
            </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

      </div>
      <div class="overlay" @click.prevent="closeconference"></div>
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex'


import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import createContact from '@/misc/firebase-init'

gsap.registerPlugin(ScrollTrigger)

// Intro Animation Scripts
require('@/misc/animations-layer')

export default {
  head() {
    return {
      title: {
        inner: 'Le LAB SUBSTANCE - Votre rendez-vous périodique',
        separator: ' ',
        complement: '',
      },
      meta: [
        {
          name: 'description',
          content: 'Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les relations publiques est de retour. Profitez de formations, conférences, discussions et activité de réseautage pour rester à l\'affût de toutes les meilleures pratiques et dernières tendances de l\'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos organisations et de vos marques dans l\'environnement actuel du marketing.',
          id: 'desc'
        },
        { name: 'application-name', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        { name: 'twitter:title', content: 'Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les relations publiques est de retour. Profitez de formations, conférences, discussions et activité de réseautage pour rester à l\'affût de toutes les meilleures pratiques et dernières tendances de l\'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos organisations et de vos marques dans l\'environnement actuel du marketing.'},
        { name: 'twitter:card', content: 'summary' },
        {
          n: 'twitter:description',
          c: 'Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les relations publiques est de retour. Profitez de formations, conférences, discussions et activité de réseautage pour rester à l\'affût de toutes les meilleures pratiques et dernières tendances de l\'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos organisations et de vos marques dans l\'environnement actuel du marketing.'
        },
        // Facebook / Open Graph
        { property: 'og:title', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        { property: 'og:site_name', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        {
          property: 'og:description',
          content: 'Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les relations publiques est de retour. Profitez de formations, conférences, discussions et activité de réseautage pour rester à l\'affût de toutes les meilleures pratiques et dernières tendances de l\'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos organisations et de vos marques dans l\'environnement actuel du marketing.'
        },
        // Og Image
        {
          p: 'og:image',
          c: 'https://substance-10-ans.netlify.app/img/og.jpg'
        },
        {
          name: 'twitter:image',
          content: 'https://substance-10-ans.netlify.app/img/og.jpg'
        }
      ]
    }
  },

  mounted() {
    this.initGsapUtils()
  },

  watch: {
    $route: {
      handler($route) {
        if ($route && $route.query.success === '1') {
          this.openform()
          this.isSuccess = true
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      form: false,
      conference: false,
      show: null,
      isSuccess: false,
      formData: {
        nom: '',
        entreprise: '',
        courriel: '',
        formations: []
      },
      isSending: false
    }
  },

  methods: {

    initGsapUtils() {
      const mtl = document.querySelector('.anim-mtl')
      const date = document.querySelector('.anim-date')
      const hour = document.querySelector('.anim-hour')

      if (mtl && date && hour) {

        gsap.to(mtl, {
          scrollTrigger: {
            trigger: mtl,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          rotation: 180,
          ease: 'none'
        })

        gsap.to(date, {
          scrollTrigger: {
            trigger: date,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          x: '-50%',
          ease: 'none'
        })

        gsap.to(hour, {
          scrollTrigger: {
            trigger: hour,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          x: '50%',
          ease: 'none'
        })
      }
    },
    
    openconference(uid) {
      this.conference = true
      this.show = uid
    },
    closeconference() {
      this.conference = false
      this.show = null
    },
    openform() {
      this.form = true
    },
    closeform() {
      this.form = false
    },
    addFormation(formation, uniqueTo = false) {
      if (uniqueTo) {
        this.formData.formations = this.formData.formations.filter(item => !item.includes(uniqueTo))
        this.formData.formations.push(formation)
        return
      }

      if (this.formData.formations.includes(formation)) {
        this.formData.formations = this.formData.formations.filter(item => item !== formation)
      } else {
        this.formData.formations.push(formation)
      }
    },
    async sendForm(event) {
      event.preventDefault()

      if (this.isSending) {
        return
      }

      this.isSending = true
      const contact = this.formData

      try {
        await createContact(contact)
        this.formData = {
          nom: '',
          entreprise: '',
          courriel: '',
          formations: []
        }
        window.location.href = '/?success=1'
      } catch (e) {
        this.error = e
        this.isSending = false
      }
    }
  },

  computed: mapState('app', ['appTitle'])
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
</style>
